/* Built In Imports */
import { useEffect, useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
//import InterestedForm from '@ila/Section/InterestedForm';
/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';

/**
 *
 */
const StickyBar = ({ sectionContent, secId = '' }) => {
  // const isMobile = useMediaQuery({ maxWidth: 767 });
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    window.addEventListener('scroll', listenToScroll);
    return () => window.removeEventListener('scroll', listenToScroll);
  }, []);

  const listenToScroll = () => {
    const footerDiv = document.getElementById('interested-form-section');
    const footerSec = document.getElementById('footersga');    
    const keyResourceLeaderIndepth = document.getElementById(
      'key-resource-leader-indepth'
    );
    const heightToHideFrom = -1;
    const winScroll =
      (document.body.scrollTop || document.documentElement.scrollTop);
    if (winScroll > heightToHideFrom) {
      if (footerDiv || footerSec || keyResourceLeaderIndepth) {
        const rect = footerDiv?.getBoundingClientRect();
        const rectfooter = footerSec?.getBoundingClientRect();
        const rectKeyResource =
          keyResourceLeaderIndepth?.getBoundingClientRect();
        const footerInViewPort =
          rect?.top <= window.innerHeight - 40 && rect?.bottom >= 20;
        const footerSecInViewPort =
          rectfooter?.top <= window.innerHeight - 40 && rectfooter?.bottom >= 20;
        const keyResourceLeaderIndepthInViewPort =
          rectKeyResource?.top <= window.innerHeight - 40 &&
          rectKeyResource?.bottom >= 20;
        if (footerInViewPort || footerSecInViewPort || keyResourceLeaderIndepthInViewPort) {
          setIsVisible(false);
        } else {
          setIsVisible(true);
        }
      } else {
        setIsVisible(true);
      }
    } else {
      setIsVisible(true);
    }
  };

  let progname = '';
  let eventKeys = '';
  if (typeof window !== 'undefined') {
    let url = window.location.href;
    if (url.includes('/human-is-not-a-resource')) {
      progname = 'HINAR';
    } else if (url.includes('/family-enterprise-excellence')) {
      progname =
        'Family Enterprise Excellence - Mapping the Future of Your Business';
    } else if (url.includes('/insight-indepth')) {
      progname = 'Insight InDepth';
      eventKeys = "sga_cta_click";
    } else if (url.includes('/insight')) {
      progname = 'INSIGHT - The DNA of Success, 2024';
    } else if (url.includes('/brand-insight')) {
      progname = 'Brand Insight - Decoding Branding';
    }else if (url.includes('/gen-a-entrepreneurship-bootcamp')) {
      progname = 'Gen A Entrepreneurship Bootcamp';
      eventKeys = "sga_cta_click";
    }else if (url.includes('/harnessing-money-magic')) {
      progname = 'Harnessing Money Magic';
      eventKeys = "sga_cta_click";
    }
  }
  const interestedClick = (url,btnText='') => {
    if (typeof window !== 'undefined') {
      window.location.href = url ? url : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Interested_Users',
        program_name: progname,
        Button_Location: '<Sticky_CTA>',
      });
      //if(progname == 'INSIGHT'){
      //smooth scroll to interested form section
      const element = document.getElementById('interested-form');
      element?.scrollIntoView({ behavior: 'smooth' });
      // <InterestedForm sectionContent={sectionContent} secId={secId} />

      //}
      if(eventKeys == 'sga_cta_click'){
        MixpanelTrigger('sga_cta_click', btnText);
      }else{
      MixpanelTrigger('iso_lead_interested_cta_clicked');
      }
      //Form load
      let fullurl = window.location.href;
      if (fullurl.includes('#interested-form-section')){
        MixpanelTrigger('iso_lead_form_impression');
      }
    }
  };

  function MixpanelTrigger(eventkey, btnText='') {
    const Mixpanel = mixPanel(window?.location.pathname);
    if(eventkey == "sga_cta_click"){
    Mixpanel.track(eventkey, {
      cta: "sticky cta",
      program_name: progname,
      element: btnText,
      
    });
  }else{
    Mixpanel.track(eventkey, {
      page_name: document.title,
      program_name: progname,
    });
   }
  }

  return (
    isVisible && (
      <>
        {sectionContent[0]?.linkUrl !== '' && (
          <Box
            maxW={{
              base: '100%',
              md: '100%',
              lg: '100%',
              xl: 1330,
              '2xl': '1330px',
            }}
            mx="auto"
            w="100%"
            position="relative"
          >
            {sectionContent[0]?.linkUrl && (
              <Flex
                justify="center"
                position="fixed"
                zIndex="99999"
                width="full"
                bg="#000000"
                left="0"
                py="20px"
                bottom="0"
                //onClick={() => interestedClick()}
              >
                <Box
                  outline="0"
                  onClick={() => interestedClick(sectionContent[0]?.linkUrl, sectionContent[0]?.buttonText)}
                  cursor={'pointer'}
                  //href={sectionContent[0]?.linkUrl}
                  px="20px"
                  py="10px"
                  minW="200px"
                  textAlign="center"
                  color="#fff"
                  fontFamily="var(--FedraSansStd-medium), sans-serif"
                  background="#F27123"
                  borderRadius="0px"
                  border="none"
                  _hover={{ background: '#BA5010' }}
                  _focus={{ background: '#BA5010' }}
                  _active={{ background: '#BA5010', border: 0 }}
                >
                  {sectionContent[0]?.buttonText}{' '}
                </Box>
              </Flex>
            )}
          </Box>
        )}
      </>
    )
  );
};

const isVisInViewport = element => {
  const rect = element?.getBoundingClientRect();
  return (
    rect?.top <= rect?.height / 4 &&
    rect?.top + rect?.height > 0 &&
    rect?.left >= 0
  );
};

export default StickyBar;
